import Div from "@jumbo/shared/Div";
import { Typography, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { t } from "i18next";
import { ASSET_IMAGES } from "../../utils/constants/paths";
import { useSearchParams } from "react-router-dom";
import InvalidTokenMessage from "./invalidTokenMessage";
import usePartnerAuth from "@jumbo/hooks/usePartnerAuth";
import activeLocale from "app/services/partner/activeLocale";
import manageToken from "./ManageToken";

const PartnerHome = () => {
  const { validate } = usePartnerAuth();
  const [validated, setValidated] = useState(null);
  const [isValidating, setIsValidating] = useState(false);
  const [searchParams] = useSearchParams();
  const token = manageToken(searchParams);
  const lang = searchParams.get("hl");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    activeLocale(lang);
    if (token) {
      setIsValidating(true);
      validate(token)
        .then((res) => {
          setValidated(true);
          try {
            const url = new URL(window.location.href);
            if (url.searchParams.has("token")) {
              url.searchParams.delete("token");
              window.history.replaceState({}, document.title, url.toString());
            }
          } catch (e) {}
        })
        .catch((error) => {
          setValidated(false);
          console.log("Token validation failed", error);
        })
        .finally(() => setIsValidating(false));
    }
  }, [token, lang]);
  if (isValidating) {
    return null;
  }
  if (validated === false) {
    return InvalidTokenMessage();
  }
  return (
    <Div>
      <Typography variant="h2">{t("dsokPartner.welcomeText")}</Typography>
      <Grid container spacing={2} alignItems={"stretch"}></Grid>
      <img src={`${ASSET_IMAGES}/dsok/kiosk-detail.png`} alt="DSOK" />
    </Div>
  );
};

export default PartnerHome;
